import { Counter } from '../../components/Counter';
import { InfoNote } from '../../components/InfoNote';
import { SectionHeader } from '../../components/SectionHeader';
import { ReservationCalendar } from '../../components/ReservationCalendar';
import { CalendarSection, GuestLabel, GuestRow, Panel } from './ReservationPanel.styles';
import type { ReservationPanelProps } from './ReservationPanel.types';

export function ReservationPanel({
  title = 'Reservation.',
  subtitle = 'Pick a date and party size.',
  guestLabel = 'Guests',
  guestCount,
  minGuests = 1,
  maxGuests,
  guestLimitNote,
  guestStep,
  onGuestCountChange,
  activeDate,
  selectedDate,
  calendarView,
  availability,
  onDateSelect,
  onWeekNavigate,
  onCalendarViewChange,
  calendarLabels,
  counterDecreaseLabel,
  counterIncreaseLabel,
}: ReservationPanelProps) {
  return (
    <Panel>
      <SectionHeader title={title} subtitle={subtitle} />
      <GuestRow>
        <GuestLabel>{guestLabel}</GuestLabel>
        <Counter
          value={guestCount}
          min={minGuests}
          max={maxGuests}
          step={guestStep}
          onChange={onGuestCountChange}
          decreaseLabel={counterDecreaseLabel}
          increaseLabel={counterIncreaseLabel}
        />
      </GuestRow>
      {guestLimitNote && <InfoNote text={guestLimitNote} />}
      <CalendarSection>
        <ReservationCalendar
          activeDate={activeDate}
          selectedDate={selectedDate}
          view={calendarView}
          availability={availability}
          onDateSelect={onDateSelect}
          onNavigate={onWeekNavigate}
          onViewChange={onCalendarViewChange}
          labels={calendarLabels}
        />
      </CalendarSection>
    </Panel>
  );
}
